import React from 'react';

import { FormattedMessage } from 'react-intl';
import { call, put, select } from 'redux-saga/effects';

import { getSavedFilingPeriodByIdRequest } from '@actions/savedFilingPeriod';
import { createDESubmissionFailure, createDESubmissionSuccess } from '@actions/submission';
import { createDESubmission } from '@api/submission';
import { requestFilesList } from '@store/filing/files/files.actions';
import { toastError, toastSuccess } from '@store/notifications';
import { selectedFilingPeriodSelector } from '@store/selectors/savedFilingPeriod';
import { selectedStandardTemplateSelector } from '@store/selectors/standardTemplate';

export const handleCreateDESubmissionSaga = function* ({ payload }) {
  try {
    const selectedStandardTemplate = yield select(selectedStandardTemplateSelector);
    const selectedFilingPeriod = yield select(selectedFilingPeriodSelector);

    const response = yield call(createDESubmission, {
      id: selectedStandardTemplate.id,
      isEncrypted: payload.isEncrypted,
      password: payload.password,
    });

    yield put(createDESubmissionSuccess(response));

    yield call(payload.onSuccess);

    yield put(getSavedFilingPeriodByIdRequest(selectedFilingPeriod.id));
    yield put(requestFilesList());
    yield put(
      toastSuccess({
        message: (
          <FormattedMessage
            defaultMessage="Electronic filing submitted successfully"
            id="global.notification.submission"
          />
        ),
      })
    );
  } catch (errors) {
    const { fieldErrors, nonFieldErrors } = errors.data || {};

    yield put([
      toastError({
        message: fieldErrors?.password || fieldErrors?.certificate || nonFieldErrors || (
          <FormattedMessage
            defaultMessage="An unexpected error occurred, please try again."
            id="global.notification.api-error-default"
          />
        ),
      }),
      createDESubmissionFailure(),
    ]);
  }
};
